import { Action } from "@ngrx/store";

export const SET_GLOBAL_SETTINGS_MODAL_VISIBILITY =
  "SET_GLOBAL_SETTINGS_MODAL_VISIBILITY";
export const SET_GLOBAL_SETTINGS_MODAL_CLOSE_ICON_VISIBILITY =
  "SET_GLOBAL_SETTINGS_MODAL_CLOSE_ICON_VISIBILITY";
export const SET_GLOBAL_SETTINGS_MODAL_ADVANCED_OPTIONS_VISIBILITY =
  "SET_GLOBAL_SETTINGS_MODAL_ADVANCED_OPTIONS_VISIBILITY";

export class SetGlobalSettingModalVisibility implements Action {
  readonly type = SET_GLOBAL_SETTINGS_MODAL_VISIBILITY;
  constructor(public payload: boolean) {}
}

export class SetGlobalSettingModalCloseIconVisibility implements Action {
  readonly type = SET_GLOBAL_SETTINGS_MODAL_CLOSE_ICON_VISIBILITY;
  constructor(public payload: boolean) {}
}

export class SetGlobalSettingModalAdvancedOptionsVisibility implements Action {
  readonly type = SET_GLOBAL_SETTINGS_MODAL_ADVANCED_OPTIONS_VISIBILITY;
  constructor(public payload: boolean) {}
}

export type Actions =
  | SetGlobalSettingModalVisibility
  | SetGlobalSettingModalCloseIconVisibility
  | SetGlobalSettingModalAdvancedOptionsVisibility;
